import { style } from '@vanilla-extract/css'

import { getFontSize } from '~/styles/mixins/font.css'
import { getMediaQuery } from '~/styles/mixins/mediaQuery.css'
import { cssVariables } from '~/styles/variables/cssVariables.css'

export const sectionTitle__default = style({})

export const sectionTitle__sub = style({})

export const sectionTitle = style({})

export const sectionTitle__small = style({})

export const sectionTitle_text = style({
  fontSize: getFontSize(24),
  fontWeight: cssVariables.font.weight.bold,

  '@media': {
    [getMediaQuery('sm')]: {
      fontSize: getFontSize(28),
    },

    [getMediaQuery('md')]: {
      fontSize: getFontSize(32),
    },
  },

  selectors: {
    [`${sectionTitle__sub} &`]: {
      color: cssVariables.color.silverChalice.hex,
    },

    [`${sectionTitle__small} &`]: {
      fontSize: getFontSize(16),
    },
  },
})
